import { DataGridColSettings } from '@/components/DataGrid/utils';

export const DIRTableColumns: DataGridColSettings[] = [
  {
    field: 'dirId',
    headerName: 'ID',
    width: 180,
    visible: true,
  },
  {
    field: 'agency',
    headerName: 'Agency',
    width: 200,
    visible: true,
  },
  {
    field: 'incidentNumber',
    headerName: 'Incident number',
    width: 180,
    visible: true,
  },
  {
    field: 'reportedDate',
    headerName: 'Reported date',
    width: 160,
    visible: true,
  },
  {
    field: 'occurredDate',
    headerName: 'Occurred date',
    width: 160,
    visible: true,
  },
  {
    field: 'complaint',
    headerName: 'Complaint number',
    width: 180,
    visible: true,
  },
  {
    field: 'address',
    headerName: 'Address',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
